var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"inputbox"},[_c('b-form-input',{staticClass:"sr__input",class:{'sr__input--invalid': !this.valid},attrs:{"disabled":_vm.disable},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}),_c('b-form-invalid-feedback',{attrs:{"state":_vm.valid}},[_vm._v(" "+_vm._s(_vm.invalidMsg)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }